import React from 'react';

import classes from './SquaredCheckbox.css';
import checked from '../../../../assets/images/Check3x.png'

const squaredCheckBox = (props) => {
  return (
    <div className={classes.SquaredCheckBox}>
      <div className={classes.SquaredRadioContainer} onClick={props.clicked}>
        <div className={classes.SquaredRadio}>
          {props.isChecked ? <img src={checked} alt="check icon" className={classes.Icon} /> : null}
        </div>
      </div>
      <div className={classes.Label}>{props.label}</div>
    </div>
  )
}

export default squaredCheckBox;





// WEBPACK FOOTER //
// ./src/components/UI/Checkbox/SquaredCheckbox/SquaredCheckbox.js